import React from "react"
import  {Link,useLocation, useParams}  from 'react-router-dom'
import styled from "styled-components"
import {useSelector} from "react-redux"
import {useAuth} from "../other/auth"


const Nav = styled.nav`
    height: 4rem;
    background: rgba(10, 10, 10, 0.8) !important;
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    padding: 0 2rem;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
`;

const Brand = styled(Link)`
    display: flex;
    align-items: center;
    img {
        height: 3rem;
        transition: transform 0.3s ease;
    }
    &:hover img {
        transform: scale(1.05);
    }
`;

const ContainerButton = styled.div`
    position: absolute;
    right: 2rem;
    display: flex;
    gap: 15px;
`

const IconButton = styled(Link)`
    color: rgba(255, 255, 255, 0.6);
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.5rem;
    padding: 0 15px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.03);
    transition: all 0.3s ease;
    text-decoration: none !important;

    &:hover {
        background: rgba(0, 210, 255, 0.1);
        color: #00d2ff;
        box-shadow: 0 0 15px rgba(0, 210, 255, 0.2);
    }

    span {
        font-size: 0.8rem;
        font-weight: bold;
        margin-left: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        display: none;
    }

    &:hover span {
        display: inline;
    }
`

const NavBar = () => {
    const fullScreen = useSelector(state => state.fullScreen);
    const location = useLocation();
    let auth = useAuth();
    const { playingMode } = useParams();

    return (
        <Nav className="navbar" style={{display : fullScreen ? "none" : "flex"}}>
            <Brand to="/">
                <img src="/img/logo_pro.png" alt="TopTV Pro" />
            </Brand>

            <ContainerButton>
                {auth.isAuth() && !location.pathname.includes("menu") && (
                <>
                    {location.pathname.includes("live") && (
                        <IconButton to={`${location.pathname.split("?")[0]}tvguide/`}>
                            <i className={"fas fa-tv"}></i>
                            <span>Guia de TV</span>
                        </IconButton>
                    )}
                    
                    <IconButton to={{
                        pathname : `${location.pathname.split("?")[0]}search/`,
                        search: window.location.search,
                    }}>
                        <i className={"fas fa-search"}></i>
                        <span>Buscar</span>
                    </IconButton>

                    <IconButton to={{
                        pathname: `/${playingMode}/category/`,
                        search: window.location.search,
                    }}>
                        <i className={"fas fa-grip-lines"}></i>
                        <span>Categorias</span>
                    </IconButton>

                    <IconButton to={`menu/`}>
                        <i className="fas fa-bars"></i>
                        <span>Menu</span>
                    </IconButton>
                </>)}
            </ContainerButton>
        </Nav>
    )
}

export default NavBar
